import { useEffect, RefObject } from 'react'

export function useClickOutside<T extends HTMLDivElement | null>(
	refs: RefObject<T>[] | RefObject<T>,
	callback: () => void
) {
	useEffect(() => {
		function handleClickOutside(event: MouseEvent | TouchEvent) {
			const refArray = Array.isArray(refs) ? refs : [refs]

			const clickedInside = refArray.some(ref =>
				ref.current?.contains(event.target as Node)
			)

			if (!clickedInside) {
				callback()
			}
		}

		document.addEventListener('mousedown', handleClickOutside)
		document.addEventListener('touchstart', handleClickOutside)

		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
			document.removeEventListener('touchstart', handleClickOutside)
		}
	}, [refs, callback])
}
